// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"440":"b0a9dc7d","502":"eef6cb7a"}[chunkId] + ".chunk.css";
};